import LiferayApiUtils from '../liferay/ApiUtils';
import LiferaySettings from '../liferay/settings';
import VirtuosoSettings from '../virtuoso/settings';
import VirtuosoApiUtils from '../virtuoso/ApiUtils';
import { ServiceContentRequest, ReplaceServiceContentRequest,
  ServiceSubjectForPurlMapRequest, ServiceTypesRequest,
  ServiceTranslateLangCheckRequest,
  ServiceUriReplacementSubjectRequest, ServiceUriReplacementPredicateRequest, 
  ServiceUriReplacementObjectRequest, ServiceUriUsedCountRequest
 } from '../virtuoso/request';

/** Специальные действия для получения информации о настройка 
 *  для сервисных функци
 * Например, наименование свойств
 */
export const ServiceRepository = {
    EMPTY: () => ({
        type: "ServiceRepository.EMPTY"
    }),
    LOAD_STARTED: () => ({
        type: "ServiceRepository.LOAD_STARTED"
    }),
    LOAD_ERROR: (error) => ({
        type: "ServiceRepository.LOAD_ERROR",
        error,
    }),


    /** Выполнение запроса CONSTRUCT для получения онтологии SKSA в графе*/
    loadOntology: () => dispatch => {  
        const options = {...LiferaySettings.options};
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/sparql_construct':{}}),
          'default_graph_uri': ServiceContentRequest.graph,
          'output_format': 'TTL',
          'query': ServiceContentRequest.sparql,
        }
        return LiferayApiUtils.postToLifeRay721(formData, options)            
          .then ((response) =>{
            return Promise.resolve(response);
          })
          .catch(e => { 
            console.log("ServiceActions.js loadOntology", e);
            dispatch(ServiceRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
            //Нельзя reject что-бы не прерывать цепочку визово
            return Promise.resolve(null);
          });
    },

    /** Полностью заменить конфигурацию в графе с настройками сервиса */
    replaceOntology: configuration => dispatch => {
      const options = { ...LiferaySettings.options };
      const request = ReplaceServiceContentRequest.cloneOriginal();

      const encoder = new TextEncoder();
      const bytes = encoder.encode(configuration);

      const rdfFile = new File([bytes],"configuration.ttl",{type: "text/turtle;charset=utf-8"});

      const formData = new FormData();

      formData.append(
        "cmd",
        JSON.stringify({
          "/mpo.mpo/sparql_import_graph": {}
        })
      );

      formData.append("formDate", String(Date.now()));
      formData.append("graph_uri", encodeURIComponent(request.graph));
      formData.append("rdffile", rdfFile, "configuration.ttl");

      // for (var key of formData.entries()) {   console.log(key[0] + ', ' + key[1])  }
      return LiferayApiUtils.postToToLifeRay721_FormData(formData, options)
        .then(response => Promise.resolve(response))
        .catch(e => {
          console.log("ServiceActions.js replaceOntology", e);
          dispatch(
            ServiceRepository.LOAD_ERROR(`Ошибка при записи конфигурации ${e}.`)
          );
          return Promise.resolve(null);
        });
    },

    loadIriForPurlMap : (rdfTypes=[], graphs=[], purlPrefix) => dispatch => {
        ServiceSubjectForPurlMapRequest.set(rdfTypes, graphs, purlPrefix);
        const options = {...LiferaySettings.options};
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/sparql_select':{}}),
          'default_graph_uri': ServiceSubjectForPurlMapRequest.graph,
          'output_format': 'TTL',
          'query': ServiceSubjectForPurlMapRequest.sparql,
        }
        return LiferayApiUtils.postToLifeRay721(formData, options)            
            .then ((response) =>{
                return Promise.resolve(response);
            })
            .catch(e => {             
                dispatch(ServiceRepository.LOAD_ERROR(`Ошибка при получении IRI для PURL мапинга ${e}.`));
                return Promise.reject(e);
            });
    },

    loadTypes : (graphs=[]) => dispatch => {
        ServiceTypesRequest.set(graphs);
        const options = {...LiferaySettings.options};
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/sparql_select':{}}),
          'default_graph_uri': ServiceTypesRequest.graph,
          'output_format': 'TTL',
          'query': ServiceTypesRequest.sparql,
        }
        return LiferayApiUtils.postToLifeRay721(formData, options)            
            .then ((response) =>{
                return Promise.resolve(response);
            })
            .catch(e => {             
                dispatch(ServiceRepository.LOAD_ERROR(`Ошибка при получении IRI для PURL мапинга ${e}.`));
                return Promise.reject(e);
            });
    },

    loadTranslateLangCheck : () => dispatch => {
        const options = {...LiferaySettings.options};
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/sparql_select_json':{}}),
          'default_graph_uri': ServiceTranslateLangCheckRequest.graph,
          'query': ServiceTranslateLangCheckRequest.sparql,
        }
        return LiferayApiUtils.postToLifeRay721(formData, options)            
            .then ((response) =>{
                return Promise.resolve(response);
            })
            .catch(e => {             
                dispatch(ServiceRepository.LOAD_ERROR(`Ошибка при получении IRI для PURL мапинга ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Заменить URI для всех субъектов */
    replaceSubjectIRI: (graphIRI, oldIRI, newIRI) => dispatch => {
        ServiceUriReplacementSubjectRequest.setGraph(graphIRI);
        ServiceUriReplacementSubjectRequest.setReplacement(oldIRI, newIRI);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': ServiceUriReplacementSubjectRequest.graph,
            'query': ServiceUriReplacementSubjectRequest.sparql,
            }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
              return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(ServiceRepository.LOAD_ERROR(`Ошибка при замене IRI ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Заменить URI для всех предикатов */
    replacePredicateIRI: (graphIRI, oldIRI, newIRI) => dispatch => {
        ServiceUriReplacementPredicateRequest.setGraph(graphIRI);
        ServiceUriReplacementPredicateRequest.setReplacement(oldIRI, newIRI);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': ServiceUriReplacementPredicateRequest.graph,
            'query': ServiceUriReplacementPredicateRequest.sparql,
            }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
              return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(ServiceRepository.LOAD_ERROR(`Ошибка при замене IRI ${e}.`));
                return Promise.reject(e);
            });
    },
    
    /** Заменить URI для всех объектов (в триплетах) */
    replaceObjectIRI: (graphIRI, oldIRI, newIRI) => dispatch => {
        ServiceUriReplacementObjectRequest.setGraph(graphIRI);
        ServiceUriReplacementObjectRequest.setReplacement(oldIRI, newIRI);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': ServiceUriReplacementObjectRequest.graph,
            'query': ServiceUriReplacementObjectRequest.sparql,
            }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
              return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(ServiceRepository.LOAD_ERROR(`Ошибка при замене IRI ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Количество URI в субъектах, предикатах и объектах  */
    usedCountIRI: (graphIRI, IRI) => dispatch => {
        const options = {...LiferaySettings.options};
        ServiceUriUsedCountRequest.setGraph(graphIRI);
        ServiceUriUsedCountRequest.setIRI(IRI);
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/sparql_select_json':{}}),
          'default_graph_uri': graphIRI,
          'query': ServiceUriUsedCountRequest.sparql,
        }
        return LiferayApiUtils.postToLifeRay721(formData, options)            
            .then ((response) =>{
                return Promise.resolve(response);
            })
            .catch(e => {             
                dispatch(ServiceRepository.LOAD_ERROR(`Ошибка при получении IRI для PURL мапинга ${e}.`));
                return Promise.reject(e);
            });
    },
};
``